import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Quote, ShieldCheck } from "lucide-react";

export default function StoriesPage() {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/stories");
        setStories(data.stories || []);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <main className="max-w-6xl mx-auto px-4 md:px-8 py-14 md:py-20" data-testid="stories-page">
      <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Verified Success Wall</span></div>
      <h1 className="font-display text-4xl md:text-5xl mv-green-text mt-3">
        Real stories. Real title deeds. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>No marketing.</span>
      </h1>
      <p className="mt-4 max-w-2xl text-[15px]" style={{ color: "var(--mv-muted)" }}>
        Every story on this page includes an anonymised title-registration reference, verified independently before publication.
      </p>

      <div className="mt-10">
        {loading ? (
          <div className="text-neutral-500">Loading stories…</div>
        ) : stories.length === 0 ? (
          <div className="mv-card p-8 flex items-start gap-4" style={{ background: "linear-gradient(180deg, #fff, rgba(212,175,55,0.06))" }}>
            <ShieldCheck className="mv-green-text shrink-0" size={26}/>
            <div>
              <div className="font-display text-xl mv-green-text">First verified stories coming soon.</div>
              <div className="text-[14px] mt-2" style={{ color: "var(--mv-muted)" }}>
                We only publish stories with a verified title-registration reference — never marketing exaggerations.
                Are you a MAVULA owner willing to share your story anonymously? Contact us via WhatsApp +44 7424 311882.
              </div>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="stories-list">
            {stories.map((s) => (
              <article key={s.id} className="mv-card p-6">
                <Quote className="mv-green-text opacity-30" size={28}/>
                <p className="mt-3 text-[15px] leading-relaxed" style={{ color: "var(--mv-text)" }}>
                  {s.story}
                </p>
                <div className="mt-5 pt-4 border-t mv-hairline flex justify-between items-end">
                  <div>
                    <div className="font-display text-lg mv-green-text">{s.author_alias}</div>
                    <div className="text-[12.5px]" style={{ color: "var(--mv-muted)" }}>{s.country} · {s.year}</div>
                  </div>
                  {s.title_ref_hash && (
                    <div className="text-[10.5px] tracking-widest uppercase px-2 py-1 rounded-full" style={{ background: "rgba(37,211,102,0.12)", color: "#0A7A2C" }}>
                      Verified · {s.title_ref_hash}
                    </div>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
